import React from "react";
import PrintTableHead from "../../../../app/ui/print/PrintTableHead";
import PrintTableNode from "../../../../app/ui/print/PrintTableNode";

const TsushokeiServiceTableHead = () => {
  return (
    <PrintTableHead height="96px">
      <PrintTableNode width="105px">
        店舗・団体名
        <div className="c-table-frame__updated-at">(最終更新日)</div>
      </PrintTableNode>
      <PrintTableNode width="90px">サービス種別</PrintTableNode>
      <PrintTableNode width="150px">住所</PrintTableNode>
      <PrintTableNode width="112px">TEL</PrintTableNode>
      <PrintTableNode width="15px">予防</PrintTableNode>
      <PrintTableNode width="72px" flexible>
        <div className="row" style={{ height: "50%" }}>
          <div className="cell">営業日</div>
        </div>
        <div className="row" style={{ height: "50%" }}>
          <div className="cell" style={{ width: "15px" }}>
            土
          </div>
          <div className="cell" style={{ width: "15px" }}>
            日
          </div>
          <div className="cell" style={{ width: "15px" }}>
            祝
          </div>
        </div>
      </PrintTableNode>
      <PrintTableNode width="15px">早朝</PrintTableNode>
      <PrintTableNode width="15px">夜間</PrintTableNode>
      <PrintTableNode width="15px">宿泊</PrintTableNode>
      <PrintTableNode width="95px">昼食提供</PrintTableNode>
      <PrintTableNode width="75px">
        リハビリ
        <br />
        機能訓練
      </PrintTableNode>
      <PrintTableNode width="65px">職員1人当たりのご利用者数</PrintTableNode>
      <PrintTableNode width="33px">定員</PrintTableNode>
      <PrintTableNode width="145px">特徴</PrintTableNode>
    </PrintTableHead>
  );
};

export default TsushokeiServiceTableHead;
